import { Module } from "vuex";
import { RootState } from ".";
import { Auth } from "firebase/auth";
import { auth } from "@/firebase";

export interface FirebaseState {
  authenticated: boolean;
  user: any;
}

export const firebase: Module<FirebaseState, RootState> = {
  namespaced: true,
  state: {
    authenticated: false,
    user: null,
  },
  getters: {
  },
  mutations: {
    signIn(state, user) {
      state.user = user;
      state.authenticated = true;
    },
    signOut(state) {
      state.user = null;
      state.authenticated = false;

    }
  },
  actions: {
    
  },
  modules: {
  }
}
